<template>
	<div class="zujuanSx">
		<div class="zujuanItem">
			<div class="zujuanTip">材料形式</div>
			<div class="zujuanR">
				<p
					:class="sxData.materialForm == '' ? 'active' : ''"
					:style="{ color: stStand && sxData.materialForm != '' ? '#aaa' : '' }"
					@click="stStand ? '' : (sxData.materialForm = '')"
				>
					全部
				</p>
				<p
					:class="sxData.materialForm == 'Q' ? 'active' : ''"
					:style="{ color: stStand && sxData.materialForm != 'Q' ? '#aaa' : '' }"
					@click="stStand ? '' : (sxData.materialForm = 'Q')"
				>
					对话
				</p>
				<p
					:class="sxData.materialForm == 'D' ? 'active' : ''"
					:style="{ color: stStand && sxData.materialForm != 'D' ? '#aaa' : '' }"
					@click="stStand ? '' : (sxData.materialForm = 'D')"
				>
					独白
				</p>
			</div>
		</div>
		<div class="zujuanItem">
			<div class="zujuanTip">著作归属</div>
			<div class="zujuanR">
				<p :class="sxData.copyright == '' ? 'active' : ''" @click="sxData.copyright = ''">全部</p>
				<p :class="sxData.copyright == '1' ? 'active' : ''" @click="sxData.copyright = '1'">原创试题</p>
				<p :class="sxData.copyright == '2' ? 'active' : ''" @click="sxData.copyright = '2'">高考真题</p>
				<p :class="sxData.copyright == '3' ? 'active' : ''" @click="sxData.copyright = '3'">综合网题</p>
			</div>
		</div>
		<div class="zujuanItem zujuanItem1">
			<div class="zujuanTip">录音主播</div>
			<div class="zujuanR">
				<p :class="sxData.anchor == '' ? 'active' : ''" @click="sxData.anchor = ''">全部</p>
				<p :class="sxData.anchor == item.dictLabel ? 'active' : ''" @click="sxData.anchor = item.dictLabel" v-for="(item, index) in zbArr" :key="index">
					{{ item.dictLabel }}
				</p>
			</div>
		</div>
		<div class="zujuanItem">
			<div class="zujuanTip">题型结构</div>
			<div class="zujuanR">
				<p
					:class="sxData.questionTypeStructure == '' ? 'active' : ''"
					:style="{ color: stStand && sxData.questionTypeStructure != '' ? '#aaa' : '' }"
					@click="stStand ? '' : (sxData.questionTypeStructure = '')"
				>
					全部
				</p>
				<p
					:class="sxData.questionTypeStructure == '1Q' ? 'active' : ''"
					:style="{ color: stStand && sxData.questionTypeStructure != '1Q' ? '#aaa' : '' }"
					@click="stStand ? '' : (sxData.questionTypeStructure = '1Q')"
				>
					一文一答
				</p>
				<p
					:class="sxData.questionTypeStructure == '2Q' ? 'active' : ''"
					:style="{ color: stStand && sxData.questionTypeStructure != '2Q' ? '#aaa' : '' }"
					@click="stStand ? '' : (sxData.questionTypeStructure = '2Q')"
				>
					一文两答
				</p>
				<p
					:class="sxData.questionTypeStructure == '3Q' ? 'active' : ''"
					:style="{ color: stStand && sxData.questionTypeStructure != '3Q' ? '#aaa' : '' }"
					@click="stStand ? '' : (sxData.questionTypeStructure = '3Q')"
				>
					一文三答
				</p>
				<p
					:class="sxData.questionTypeStructure == '4Q' ? 'active' : ''"
					:style="{ color: stStand && sxData.questionTypeStructure != '4Q' ? '#aaa' : '' }"
					@click="stStand ? '' : (sxData.questionTypeStructure = '4Q')"
				>
					一文四答
				</p>
			</div>
		</div>
		<div class="zujuanItem">
			<div class="zujuanTip zujuanTip1s">
				难易度
				<el-tooltip class="item" effect="dark" content="系数越小越困难，系数越大越简单" placement="top">
					<i class="el-icon-question" style="color: #9a9a9a"></i>
				</el-tooltip>
			</div>
			<div class="zujuanR">
				<el-checkbox-group v-model="sxData.difficultyScore">
					<el-checkbox :label="`${(i * 0.1).toFixed(1)}`" v-for="i in 10" :key="i"></el-checkbox>
				</el-checkbox-group>
			</div>
		</div>
		<div class="zujuanItem">
			<div class="zujuanTip zujuanTip2s">年级</div>
			<div class="zujuanR">
				<p :class="sxData.gradeClassificationId == '' ? 'active' : ''" @click="sxData.gradeClassificationId = ''">全部</p>
				<p
					:class="sxData.gradeClassificationId == item.classificationId ? 'active' : ''"
					v-for="(item, index) in njArr"
					:key="index"
					@click="sxData.gradeClassificationId = item.classificationId"
				>
					{{ item.classificationName }}
				</p>
			</div>
		</div>
		<div class="zujuanItem zujuanItem1">
			<div class="zujuanTip zujuanTip1s">疑问词</div>
			<div class="zujuanR">
				<el-checkbox-group v-model="sxData.interrogativeId">
					<el-checkbox v-for="(item, index) in ywjArr" :key="item.classificationId" :label="item.classificationId">{{ item.classificationName }}</el-checkbox>
				</el-checkbox-group>
			</div>
		</div>
		<div class="zujuanItem">
			<div class="zujuanTip zujuanTip2s">
				<span>词数</span>
				<el-tooltip class="item" effect="dark" content="指录音含有的单词数量（不含标点）" placement="top">
					<i class="el-icon-question" style="color: #9a9a9a"></i>
				</el-tooltip>
			</div>
			<div class="zujuanR">
				<el-checkbox-group v-model="sxData.cisVal">
					<el-checkbox v-for="(item, index) in csArr" :key="index" :label="item.classificationName" :value="item.classificationId"></el-checkbox>
				</el-checkbox-group>
			</div>
		</div>
		<div class="zujuanItem" v-if="sxData.materialForm != 'D'">
			<div class="zujuanTip zujuanTip2s">
				轮次
				<el-tooltip class="item" effect="dark" content="指录音原文中情景对话的回合数" placement="top">
					<i class="el-icon-question" style="color: #9a9a9a"></i>
				</el-tooltip>
			</div>
			<div class="zujuanR">
				<el-checkbox-group v-model="sxData.roundsId">
					<el-checkbox v-for="(item, index) in lcArr" :key="index" :label="item.classificationId">{{ item.classificationName }}</el-checkbox>
				</el-checkbox-group>
			</div>
		</div>
		<div class="zujuanItem" style="margin-top: 20px">
			<div class="zujuanTip zujuanTip2s">
				话题
				<el-tooltip class="item" effect="dark" content="指录音原文中情景对话的主要内容" placement="top">
					<i class="el-icon-question" style="color: #9a9a9a"></i>
				</el-tooltip>
			</div>
			<div class="zujuanR">
				<!-- <el-input v-model.trim="sxData.topic" class="myInput" placeholder="输入话题关键词" autocomplete="off"></el-input> -->
				<el-autocomplete
					class="myInput"
					v-model="sxData.topic"
					:fetch-suggestions="querySearchTopic"
					placeholder="输入话题关键词"
					:trigger-on-focus="false"
					@select="handleSelectTopic"
				></el-autocomplete>
				<el-radio-group class="myradios" v-model="sxData.topicSearchType">
					<el-radio label="1">精准搜索</el-radio>
					<el-radio label="2">模糊搜索</el-radio>
				</el-radio-group>
				<p class="myps" v-if="htNum">此类话题已检索出试题{{ htNum }}套</p>
			</div>
		</div>
		<div class="zujuanItem" style="margin-top: 20px">
			<div class="zujuanTip zujuanTip2s">
				考点
				<el-tooltip class="item" effect="dark" content="指本段材料试题问答的考试意图" placement="top">
					<i class="el-icon-question" style="color: #9a9a9a"></i>
				</el-tooltip>
			</div>
			<div class="zujuanR">
				<!-- <el-input v-model.trim="sxData.testCenter" class="myInput" placeholder="输入考点关键词" autocomplete="off"></el-input> -->
				<el-autocomplete
					class="myInput"
					v-model="sxData.testCenter"
					:fetch-suggestions="querySearchTestCenter"
					placeholder="输入考点关键词"
					:trigger-on-focus="false"
					@select="handleSelectTestCenter"
				></el-autocomplete>
				<el-radio-group class="myradios" v-model="sxData.testCenterSearchType">
					<el-radio label="1">精准搜索</el-radio>
					<el-radio label="2">模糊搜索</el-radio>
				</el-radio-group>
				<p class="myps" v-if="kdNum">此类话题已检索出试题{{ kdNum }}套</p>
			</div>
		</div>
		<div class="zujuanItem">
			<div class="zujuanBtns">
				<div class="zujuanBtn supHove3" v-if="!disBtn" @click="czBtn">重置</div>
				<el-button class="zujuanBtn zujuanBtn1 supHove3" @click="subBtn" :class="disBtn ? 'disBtn' : ''">检索</el-button>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
export default {
	name: 'shaixTel',
	data() {
		return {
			// 1年级 2 话题 3 考点 4 疑问词 5 词数 6 轮次
			njArr: [],
			ywjArr: [],
			csArr: [],
			lcArr: [],
			zbArr: [],
			stStand: '',
			sxData: {
				gradeClassificationId: null,
				questionTypeStructure: null,
				anchor: null,
				copyright: null,
				materialForm: null,
				difficultyScore: [],
				interrogativeId: [],
				cisVal: [],
				roundsId: [],
				topic: '',
				topicSearchType: '1',
				testCenter: '',
				testCenterSearchType: '1',
			},
			restaurants: [
				{
					value: '测试1'
				},
				{
					value: '测试2'
				},
				{
					value: '测试3'
				},
				{
					value: '测试4'
				},
				{
					value: '测试5'
				},
				{
					value: '测试6'
				},
				{
					value: '测试7'
				},
				{
					value: '测试8'
				},
				{
					value: '测试9'
				},
			]
		};
	},
	props: {
		disBtn: {
			type: Boolean,
			default: false
		},
		htNum: {
			type: Number,
			default: 0
		},
		kdNum: {
			type: Number,
			default: 0
		}
	},
	computed: {
		...mapState(['temTestquest'])
	},
	methods: {
		async querySearchTopic(queryString, cb) {
			let res = await this.$http.get(`api/app/yydExaminationQuestionClassification/selectList/${2}`, {
				params: {
					classificationName: this.sxData.topic
				}
			})
			var restaurants = res.data || [];
			restaurants.forEach(v => {
				v.value = v.classificationName || ''
			})
			// var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
			// 调用 callback 返回建议列表的数据
			cb(restaurants);
		},
		handleSelectTopic(item) {
			console.log('handleSelect', item);
		},
		async querySearchTestCenter(queryString, cb) {
			let res = await this.$http.get(`api/app/yydExaminationQuestionClassification/selectList/${3}`, {
				params: {
					classificationName: this.sxData.testCenter
				}
			})
			var restaurants = res.data || [];
			restaurants.forEach(v => {
				v.value = v.classificationName || ''
			})
			// var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
			// 调用 callback 返回建议列表的数据
			cb(restaurants);
		},
		handleSelectTestCenter(item) {
			console.log('handleSelect', item);
		},
		createFilter(queryString) {
			return (restaurant) => {
				return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
			};
		},
		subBtn() {
			if (this.disBtn) {
				return;
			}
			if (this.sxData.materialForm == 'D') {
				this.sxData.roundsId = [];
			}

			this.$emit('dataFn', {
				pageNum: 1,
				pageSize: 10
			});
		},
		czBtn() {
			if (this.disBtn) {
				return;
			}
			this.sxData = {
				gradeClassificationId: null,
				questionTypeStructure: null,
				anchor: null,
				copyright: null,
				materialForm: null,
				difficultyScore: [],
				interrogativeId: [],
				cisVal: [],
				roundsId: [],
				topic: '',
				topicSearchType: '1',
				testCenter: '',
				testCenterSearchType: '1'
			};
		},
		init() {
			// 主播
			this.$http.get(`api/system/dict/data/type/sys_anchor`).then((res) => {
				if (res.code == 200) {
					this.zbArr = res.data || [];
				}
				console.log(res, 'zb');
			});
			// 1 年级
			this.$http.get(`api/app/yydExaminationQuestionClassification/selectList/${1}`).then((res) => {
				if (res.code == 200) {
					this.njArr = res.data || [];
				}
				console.log(res, 1111);
			});
			//  4 疑问词
			this.$http.get(`api/app/yydExaminationQuestionClassification/selectList/${4}`).then((res) => {
				if (res.code == 200) {
					this.ywjArr = res.data || [];
				}
				console.log(res, 44444);
			});
			// 5 词数
			this.$http.get(`api/app/yydExaminationQuestionClassification/selectList/${5}`).then((res) => {
				if (res.code == 200) {
					this.csArr = res.data || [];
				}
				console.log(res, 55555);
			});
			// 6 轮次
			this.$http.get(`api/app/yydExaminationQuestionClassification/selectList/${6}`).then((res) => {
				if (res.code == 200) {
					this.lcArr = res.data || [];
				}
				console.log(res, 6666);
			});
		}
	},
	mounted() {
		const { stStand } = this.$route.query;
		if (stStand) {
			console.log(stStand, 7777);
			this.stStand = JSON.parse(stStand);
			this.sxData.questionTypeStructure = this.stStand.num + 'Q';
			this.sxData.materialForm = this.stStand.type;
		}
		this.init();
	}
};
</script>
<style lang="scss" scoped>
.zujuanSx {
	.zujuanItem {
		font-size: 14px;
		color: #000000;
		display: flex;
		align-items: center;
		margin-bottom: 10px;
		.zujuanBtns {
			display: flex;
			justify-content: end;
			flex: 1;
			.zujuanBtn {
				width: 88px;
				height: 40px;
				background: #ffffff;
				box-shadow: 0px 1px 2px 0px rgba(184, 200, 224, 0.22);
				border: 1px solid #d8e0f0;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 16px;
				color: #000000;
				margin-left: 25px;
				box-sizing: border-box;
				border-radius: 6px;
				cursor: pointer;
			}
			.zujuanBtn1 {
				background: #1d7b3a;
				color: #fff;
				border: none;
			}
		}
		.zujuanTip {
			width: 76px;
			display: flex;
			color: #9a9a9a;
			align-items: center;
			i {
				margin-left: 4px;
				cursor: pointer;
			}
		}
		.zujuanTip1s {
			letter-spacing: 1px;
			i {
				margin-left: 2px;
			}
		}
		.zujuanTip2s {
			letter-spacing: 15px;
			i {
				margin-left: -11px;
			}
		}
		.zujuanR {
			display: flex;
			align-items: center;
			flex-wrap: wrap;
			flex: 1;
			p {
				margin-right: 40px;
				cursor: pointer;
			}
			.myradios {
				display: flex;
				margin: 0 51px 0 12px;
				color: #000000;
				font-size: 12px;
			}
			.myInput {
				width: 250px;
				::v-deep .el-input__inner {
					height: 32px;
				}
			}
			.myps {
				flex: 1;
				width: auto;
				display: flex;
				font-size: 12px;
				color: #9a9a9a;
				margin-top: -4px;
			}
			.active {
				color: #1d7b3a;
			}
		}
	}
	.zujuanItem1 {
		align-items: flex-start;
		.zujuanR {
			p {
				margin-bottom: 4px;
			}
		}
	}
}

.disBtn {
	background: rgba(29, 123, 58, 0.5) !important;
	cursor: not-allowed !important;
}
//在全局设置
::v-deep .el-radio input[aria-hidden='true'] {
	display: none !important;
}

::v-deep .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
	box-shadow: none !important;
}
</style>
